import styled from 'styled-components';

interface ProgressProps {
  $percent: number;
  $lender: string;
  $type?: 'otherDebts' | 'potentialSavings';
}

interface ContainerProps {
  $isHidden: boolean;
}

export const Container = styled.div<ContainerProps>`
  height: 0.438rem;
  width: 100%;
  position: relative;
  display: ${({ $isHidden }) => ($isHidden ? 'none' : 'block')};
`;

export const BaseBox = styled.div`
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 0.188rem;
  transition: width 0.5s ease-in-out;
`;

export const Background = styled(BaseBox)`
  background: ${(props) => props.theme.colors.bgProgressGrey};
  width: 100%;
`;

export const Progress = styled(BaseBox)<ProgressProps>`
  width: ${({ $percent }) => $percent}%;

  background: ${({ $lender, $type, theme }) => {
    const origin = $lender?.toLowerCase() || '';

    if ($type === 'potentialSavings') {
      return theme.colors.potentialSavings;
    }

    if ($type === 'otherDebts') {
      return origin.includes('loandepot') ? theme.colors.bgLightLilac : theme.colors.bgLightGray;
    }

    return origin.includes('loandepot') ? theme.colors.primary : theme.colors.primaryColor;
  }};
`;
